import PropTypes from "prop-types"

const SelectedHeader = ({
	selectedList,// = [],
	actions,// = <div>X item selected</div>
}) => {

	return <>
		{selectedList?.length > 0 && (
			<div
				className="data-table3__table__head__row secondary"
			>
				<span>
					{selectedList.length} item selected:
				</span>
				{actions}
			</div>
		)}
	</>
}

SelectedHeader.propTypes = {
	selectedList: PropTypes.array,
	actions: PropTypes.node
}

export default SelectedHeader;
